import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54223fc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav-info" }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户信息", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户管理", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_switch_button = _resolveComponent("switch-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_user_filled = _resolveComponent("user-filled")!
  const _component_setting = _resolveComponent("setting")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, { trigger: "click" }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, {
              class: "user-logout",
              onClick: _ctx.handleExitClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_switch_button)
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_dropdown_item, { divided: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user_filled)
                  ]),
                  _: 1
                }),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_setting)
                  ]),
                  _: 1
                }),
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            size: "small",
            src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.userName), 1)
        ])
      ]),
      _: 1
    })
  ]))
}